import { SCORE_LABELS } from "@/data/questions";

export default function ScorePicker({ value, onChange, testIdPrefix }) {
  return (
    <div className="mt-5">
      <div className="text-xs uppercase tracking-[0.18em] text-[var(--tt-muted)] mb-3">
        Rate yourself · 1–5
      </div>
      <div className="grid grid-cols-5 gap-2 sm:gap-3">
        {[1, 2, 3, 4, 5].map((n) => {
          const active = value === n;
          return (
            <button
              key={n}
              type="button"
              onClick={() => onChange(n)}
              data-testid={`${testIdPrefix}-score-${n}`}
              className={`tt-score border rounded-xl py-3 sm:py-4 flex flex-col items-center justify-center text-sm sm:text-base font-semibold ${
                active
                  ? "tt-score-active"
                  : "bg-[var(--tt-surface)] border-[var(--tt-border)] text-[var(--tt-text)]"
              }`}
            >
              <span className="font-display text-xl sm:text-2xl">{n}</span>
              <span className="text-[10px] sm:text-[11px] font-medium opacity-80 mt-0.5 text-center px-1 leading-tight">
                {SCORE_LABELS[n]}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
